import * as React from 'react'
import { IOption, IProviderProps } from '@user/components/Filters'
import { useQuery } from 'react-query'
import { ServiceConfig } from '@user/store/services/config'
import { ENTITY_TYPES, get } from '@sales-center/common'
import { ImportFilterDTO } from '@user/components/Leads/LeadFilters/typings'

export const ImportNameProvider: React.FC<IProviderProps> = ({ render }) => {
  const { data, isFetching } = useQuery(
    ['filters', 'opp', 'importName'],
    async (): Promise<IOption[]> => {
      const result = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.import.getFilterEntries}/${ENTITY_TYPES.Opportunity}`,
      )

      const filterEntries: ImportFilterDTO[] = await result.json()

      const options: IOption[] = filterEntries.map(({ id, name }) => ({
        value: id,
        label: name,
      }))

      return options
    },
  )

  return <>{render(data ?? [], isFetching)}</>
}
ImportNameProvider.displayName = 'ImportNameProvider'
